import React, { useEffect, useState } from "react";
import { Flame, Trophy } from "lucide-react";
import { getLeaderboard, getReferralBoard } from "@/api";

const short = (a) => (a ? `${a.slice(0, 6)}…${a.slice(-4)}` : "");

export default function LeaderboardPage() {
  const [data, setData] = useState(null);
  const [tab, setTab] = useState("flame");

  useEffect(() => {
    Promise.all([getLeaderboard(), getReferralBoard().catch(() => ({ top_recruiters: [] }))]).then(([a, b]) => setData({ ...a, ...b }));
  }, []);

  const rows = data ? (tab === "flame" ? data.top_flame : tab === "farm" ? data.top_farmers || [] : tab === "ref" ? data.top_recruiters || [] : data.top_burn) : [];

  return (
    <div className="pt-24 pb-20">
      <div className="max-w-5xl mx-auto px-4">
        <h1 className="font-display text-3xl sm:text-4xl font-black flex items-center gap-2"><Trophy className="text-amber-400" /> Leaderboard</h1>

        <div className="mt-5 -mx-4 px-4 flex gap-2 overflow-x-auto pb-2 [&>button]:shrink-0 [&>button]:whitespace-nowrap">
          <button data-testid="leaderboard-tab-earners" onClick={() => setTab("flame")} className={`btn-tactile ${tab === "flame" ? "btn-flame" : "btn-ghost"}`}>Top FLAME Earners</button>
          <button data-testid="leaderboard-tab-burners" onClick={() => setTab("burn")} className={`btn-tactile ${tab === "burn" ? "btn-cronos" : "btn-ghost"}`}>Top CRO Burners</button>
          <button data-testid="leaderboard-tab-farmers" onClick={() => setTab("farm")} className={`btn-tactile ${tab === "farm" ? "btn-gold" : "btn-ghost"}`}>Top Farmers</button>
          <button data-testid="leaderboard-tab-recruiters" onClick={() => setTab("ref")} className={`btn-tactile ${tab === "ref" ? "btn-gold" : "btn-ghost"}`}>Top Recruiters</button>
        </div>

        <div className="mt-5 card-tile" data-testid="leaderboard-table">
          <div className="grid grid-cols-12 font-pixel text-[9px] text-slate-400 px-3 pb-2 border-b border-white/10">
            <div className="col-span-1">#</div>
            <div className="col-span-5 sm:col-span-6">PLAYER</div>
            <div className="col-span-4 sm:col-span-3 text-right pr-2">{tab === "flame" ? "FLAME" : tab === "farm" ? "FLAME HARVESTED" : tab === "ref" ? "INVITES (FLAME)" : "CRO BURNED"}</div>
            <div className="col-span-2 text-right">STREAK</div>
          </div>
          {rows.length === 0 && <div className="text-slate-500 italic p-6 text-center">No players yet. Be the first to burn!</div>}
          {rows.map((r, i) => (
            <div key={`${tab}-${r.address}-${i}`} data-testid={`leaderboard-row-${i}`} className="grid grid-cols-12 items-center py-3 px-3 border-b border-white/5 hover:bg-white/5">
              <div className="col-span-1 font-pixel text-[11px] text-amber-400">{i + 1}</div>
              <div className="col-span-5 sm:col-span-6 font-mono text-xs sm:text-sm">{short(r.address)}</div>
              <div className="col-span-4 sm:col-span-3 text-right font-mono text-sm sm:text-base pr-2 flex items-center justify-end gap-1 text-orange-400">
                <Flame size={14} /> {tab === "flame" ? r.flame : tab === "farm" ? r.farm_flame : tab === "ref" ? `${r.qualified} (${r.flame_earned})` : Number(r.cro_burned).toFixed(4)}
              </div>
              <div className="col-span-2 text-right text-amber-300">{r.streak || 0}🔥</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
